import { useState } from 'react';

import { HeaderContext } from '@app/providers/HeaderProvider/HeaderContext';
import type { NHeaderProvider } from '@app/providers/HeaderProvider/HeaderProvider.types';

export const HeaderProvider: NHeaderProvider.Main = ({ children }) => {
  const [header, setHeader] = useState<NHeaderProvider.Header>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);

  return (
    <HeaderContext.Provider
      value={{
        header,
        setHeader,
        isLoading,
        setIsLoading,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};
